import { Stack } from '@mui/material';
import styled from 'styled-components';

import { SelectedItemContainer } from '@/shared/components/ui/selected-items-list/components/selected-item/selected-item.styled';
import { ErrorContainer } from '@/shared/features/error/error.styled';

export const LinkedSecretsErrorContainer = styled(ErrorContainer)`
  && {
    width: 100%;
    padding: 1rem;
    gap: 0.5rem;
    background-color: ${({ theme }) => theme.palette.danger.light};
    border: 1px solid ${({ theme }) => theme.palette.status.red.stroke};
  }
`;

export const LinkedSecretsTitleRow = styled(Stack)`
  && {
    flex-direction: row;
    align-items: flex-start;
    gap: 0.5rem;

    svg {
      color: ${({ theme }) => theme.palette.status.red.text};
      flex-shrink: 0;
      margin-top: 0.25rem;
    }
  }
`;

export const LinkedSecretItemContainer = styled(SelectedItemContainer)`
  && {
    flex-shrink: 0;
  }
`;
